import { useMutation } from '@tanstack/react-query';
import { HeapService } from '../../generated';

interface GetPresignedDownloadUrlProps {
  jobsiteId: string;
  bucket: string;
  object: string;
}

export function useGetPresignedDownloadUrl() {
  return useMutation({
    mutationFn: async ({ jobsiteId, bucket, object }: GetPresignedDownloadUrlProps) =>
      HeapService.heapControllerGetPresignedDownloadUrl({
        path: { jobsiteId },
        body: { bucket: bucket, object: object },
      }),
  });
}
